import React from 'react';
import { Link } from 'react-router-dom';
import { BellRing, Inbox, ArrowRightLeft, CheckCircle2 } from 'lucide-react';
import { PendBadge, Countdown } from '../pendencias/pendShared';
import { SlaBadge } from '../leadmgmt/lmShared';
import { companyLabel, clientUrl } from '../client360/c360Shared';

const Box = ({ icon: Icon, title, count, tone, children, testId }) => (
  <div className="rounded-xl border border-slate-200 bg-white p-4 space-y-2" data-testid={testId}>
    <div className="flex items-center gap-2">
      <span className={`w-8 h-8 rounded-full flex items-center justify-center ${tone}`}><Icon className="w-4 h-4" /></span>
      <h3 className="font-semibold text-slate-800 flex-1">{title}</h3>
      <span className="text-lg font-bold font-[Outfit]">{count}</span>
    </div>
    <div className="max-h-64 overflow-y-auto divide-y divide-slate-100">{children}</div>
  </div>
);
const Line = ({ to, children }) => <Link to={to} className="flex items-center gap-2 py-1.5 text-sm hover:text-[#2D3E6F]">{children}</Link>;
const cli = (nif, nome, contractId) => clientUrl(nif, nome, { contractId });

export const TodoPanel = ({ pf }) => {
  const total = pf.pendencias.length + pf.leads_alerta.length + pf.hora_de_mudar.length;
  return (
    <div className="rounded-2xl border border-rose-200 bg-rose-50/50 p-4 space-y-3" data-testid="com360-todo">
      <div>
        <h2 className="text-base md:text-lg font-bold font-[Outfit] text-rose-900">O que tem por fazer ({total})</h2>
        <p className="text-xs text-rose-800/80">Pendências do gestor, leads paradas ou a expirar e clientes em "hora de mudar".</p>
      </div>
      {total === 0 ? (
        <div className="flex items-center gap-2 text-sm text-emerald-800"><CheckCircle2 className="w-4 h-4" />Tudo em dia.</div>
      ) : (
        <div className="grid gap-3 lg:grid-cols-3">
          <Box icon={BellRing} title="Pendências" count={pf.pendencias.length} tone="bg-rose-600 text-white" testId="com360-todo-pend">
            {pf.pendencias.map((p) => (
              <Line key={p.id} to="/pendencias"><span className="flex-1 truncate">{p.client_name}</span>
                {['enviado', 'lido'].includes(p.status) ? <Countdown deadline={p.deadline_at} /> : <PendBadge status={p.status} />}</Line>
            ))}
          </Box>
          <Box icon={Inbox} title="Leads em alerta" count={pf.leads_alerta.length} tone="bg-amber-100 text-amber-700" testId="com360-todo-leads">
            {pf.leads_alerta.map((l) => (
              <Line key={l.id} to={`/leads/${l.id}`}><span className="flex-1 truncate">{l.client_name}</span><SlaBadge sla={l.sla} /></Line>
            ))}
          </Box>
          <Box icon={ArrowRightLeft} title="Hora de mudar" count={pf.hora_de_mudar.length} tone="bg-[#2D3E6F] text-white" testId="com360-todo-mudar">
            {pf.hora_de_mudar.map((s) => (
              <Line key={s.contract_id} to={cli(s.nif, s.nome, s.contract_id)}><span className="flex-1 truncate">{s.nome}</span><span className="text-xs text-slate-500">{companyLabel(s.company)}</span></Line>
            ))}
          </Box>
        </div>
      )}
    </div>
  );
};
